/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import * as e from "react";
import { useId as m, useUnstyled as f } from "@progress/kendo-react-common";
import { useLocalization as R, useInternationalization as p } from "@progress/kendo-react-intl";
import { useGridState as z } from "./GridState.mjs";
import { cloneReactElement as C } from "./utils/index.mjs";
const L = (t) => {
  const o = m(), n = t.id || o, c = f(), i = R(), r = p(), [, s] = e.useReducer((u) => !u, !0), a = e.useRef(0), [l, , d] = z();
  return C(t.children, {
    ...l,
    ...d,
    id: n,
    unstyled: c,
    localization: i,
    intl: r,
    scrollLeftRef: a,
    forceUpdate: s,
    isClient: !0
  });
};
export {
  L as GridClientContextReader
};
